module.exports = __webpack_public_path__ + "assets/img/question_play.bf616c91.png";